import { useAutoUpdate } from '@/context/AutoUpdateContext';

const UpdateReadyPopup: React.FC = () => {
  const { status, popupOpen, handleRemindLater, handleRestartNow } = useAutoUpdate();

  if (typeof window === 'undefined' || !window.electron?.isElectron) {
    return null;
  }

  if (!popupOpen || status.status !== 'downloaded' || status.mandatory) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[99990] flex items-center justify-center bg-gray-900/60 px-4">
      <div className="w-full max-w-[380px] rounded-[28px] bg-white p-6 shadow-2xl dark:bg-gray-900">
        <div className="mb-5 flex justify-center">
          <div className="relative flex h-[180px] w-full items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br from-[#F1EEFC] via-[#E9E4FB] to-[#E9E4FB]">
            <img
              src="./images/UpdatePopUpImage.png"
              alt=""
              className="h-[140px] w-[140px] object-contain"
            />
          </div>
        </div>
        <div className="mb-4 flex justify-center">
          <span className="rounded-full bg-green-100 px-4 py-1.5 text-sm font-medium text-green-700 dark:bg-green-900/30 dark:text-green-300">
            Update Available
          </span>
        </div>
        <h2 className="mb-2 text-center text-2xl font-bold leading-tight text-gray-900 dark:text-gray-100">
          Your Store Just Got Faster,
          <br />
          Update Now!
        </h2>
        <p className="mb-8 text-center text-sm text-gray-500 dark:text-gray-400">
          Restart the application to launch the update
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={handleRemindLater}
            className="flex-1 rounded-full bg-indigo-50 px-4 py-3 font-medium text-indigo-700 transition-colors hover:bg-indigo-100 dark:bg-indigo-900/30 dark:text-indigo-300 dark:hover:bg-indigo-900/50"
          >
            Update Later
          </button>
          <button
            type="button"
            onClick={handleRestartNow}
            className="flex-1 rounded-full bg-indigo-600 px-4 py-3 font-medium text-white transition-colors hover:bg-indigo-700"
          >
            Restart to Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateReadyPopup;
